import { render, staticRenderFns } from "./BaseInputPrice.vue?vue&type=template&id=7a54e705&"
import script from "./BaseInputPrice.vue?vue&type=script&lang=js&"
export * from "./BaseInputPrice.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputPrice.vue?vue&type=style&index=0&id=7a54e705&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports